import { msg } from "components/schema/msg";
import { validationPatterns } from "constant/validationPatterns";
import * as Yup from "yup";

export const SubCategorySchema = Yup.object().shape({
  name: Yup.string()
    .matches(validationPatterns.name, msg("subCategoryLetters"))
    .min(2, msg("subCategoryMin"))
    .required(msg("subCategoryRequired")),
});
